export class HsaPeroidContribution {
    hsaContributionYearTotalEstimated: number;
    hsaContributionReductionAmount: number;
    hsaFirstDeductionDate: string;
    hsaLastFullDeductionDate: string;
    hsaDeductionReducedDate: string;
    hsaDisplayReductionMessage: boolean;
    hsaReducedNumDeductionsRemaining: number;
    payPeriodContribution: number;

    constructor() {
        this.hsaContributionYearTotalEstimated = 0;
        this.hsaContributionReductionAmount = 0;
        this.hsaFirstDeductionDate = null;
        this.hsaLastFullDeductionDate = null;
        this.hsaDeductionReducedDate = null;
        this.hsaDisplayReductionMessage = false;
        this.hsaReducedNumDeductionsRemaining = 0;
        this.payPeriodContribution = 0;
    }
}

export class HSAContributionPayload {
    payPeriodContribution: number;

    constructor() {
        this.payPeriodContribution = 0;
    }
}